import React from "react";
import "./GameIntro.scss";
import { TOTAL_LEVEL, INITIAL_LIVES } from "../../constants/GameConstants";
import { storage } from "../../utilities/storage";
import { GC } from "../../utilities/GamecentreSevice";

export default function GameIntro(props) {
    const gameDetails = storage.get.gameDetails();

    return (<>
        <div className="game-intro">
            <div className="game-intro__main-container">
                <div className="game-intro__main-container__intro-section">
                    <div className="game-intro__main-container__intro-section__content">
                        <img
                            className="game-intro__main-container__intro-section__content__logo"
                            src={gameDetails?.mediaUrl || require("../../static/img/home-page-logo.png")}
                            alt=""
                        />
                        {
                            gameDetails?.organizationName &&
                            <p className="game-intro__main-container__intro-section__content__orgName">
                                Powered by <span style={{ fontWeight: '700' }}>{gameDetails.organizationName}</span>
                            </p>
                        }
                        <div className="game-intro__main-container__intro-section__content__title">
                            🎯 Instructions
                        </div>
                        <div className="game-intro__main-container__intro-section__content__sub-title">
                            You’ll see a grid of tiles and you have to tap them in a sequence based on some simple rules.
                            Just don’t forget the rules!
                            <br /><br />
                            <b>Warning: You’ll lose a life each time you make a mistake!</b>
                        </div>

                        <div className="game-intro__main-container__intro-section__content__stats-container">
                            {/* Levels Completed */}
                            <div className="game-intro__main-container__intro-section__content__stats-container__stat">
                                <p className="stat__title">Levels</p>
                                <p className="stat__value">
                                    {TOTAL_LEVEL}
                                </p>
                            </div>

                            {/* Accuracy */}
                            <div className="game-intro__main-container__intro-section__content__stats-container__stat">
                                <p className="stat__title">Lives</p>
                                <p className="stat__value">
                                    {INITIAL_LIVES}
                                </p>
                            </div>
                        </div>


                        <button
                            className="game-intro__main-container__intro-section__content__primary-button"
                            onClick={() => {
                                const gameData = storage.get.levelData() ?? {};
                                if (gameData && !gameData?.levelData?.length) {
                                    GC.createGameMasterSession();
                                }
                                props.history.push("/level-info")
                            }}
                        >
                            Start Game
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}